import { FC } from "react";
import { Typography } from "antd";

/** Предпросмотр плеера ВК — так видео увидят на ФНЛ ТВ. */
export const VkPreview: FC<{
  embedUrl?: string | null;
  vertical?: boolean;
}> = ({ embedUrl, vertical }) =>
  embedUrl ? (
    <div
      style={{
        position: "relative",
        width: vertical ? 270 : "100%",
        maxWidth: 640,
        aspectRatio: vertical ? "9 / 16" : "16 / 9",
        background: "#000",
        borderRadius: 8,
        overflow: "hidden",
      }}
    >
      <iframe
        title="Плеер ВК"
        src={embedUrl}
        style={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          border: 0,
        }}
        allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
        allowFullScreen
      />
    </div>
  ) : (
    <Typography.Text type="secondary">
      Плеер появится после сохранения ссылки ВК
    </Typography.Text>
  );
